export function getRegionFromLocaleCode(locale: string): string {
  const [language, region] = locale.toUpperCase().split(/[_-]+/);
  return region || language || 'US';
}
